import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SupplierCard = ({ supplier, consumablesCount, onEdit, onDelete }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-5 hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
            <Icon name="Building2" size={24} className="text-primary" />
          </div>
          <div>
            <h3 className="font-semibold text-foreground">{supplier?.name}</h3>
            {supplier?.contact_person && (
              <p className="text-xs text-muted-foreground">{supplier?.contact_person}</p>
            )}
          </div>
        </div>
        <div className={`px-2 py-1 rounded text-xs font-medium ${
          supplier?.is_active 
            ? 'bg-success/10 border-success/20 text-success' :'bg-muted border-border text-muted-foreground'
        }`}>
          {supplier?.is_active ? 'Actif' : 'Inactif'}
        </div>
      </div>

      <div className="space-y-2 mb-4">
        {supplier?.email && (
          <div className="flex items-center gap-2 text-sm">
            <Icon name="Mail" size={14} className="text-muted-foreground" />
            <span className="text-foreground">{supplier?.email}</span>
          </div>
        )}
        
        {supplier?.phone && (
          <div className="flex items-center gap-2 text-sm">
            <Icon name="Phone" size={14} className="text-muted-foreground" />
            <span className="text-foreground">{supplier?.phone}</span>
          </div>
        )}
        
        {supplier?.city && (
          <div className="flex items-center gap-2 text-sm">
            <Icon name="MapPin" size={14} className="text-muted-foreground" />
            <span className="text-foreground">{supplier?.city}, {supplier?.country || 'France'}</span>
          </div>
        )}
        
        {supplier?.website && (
          <div className="flex items-center gap-2 text-sm">
            <Icon name="Globe" size={14} className="text-muted-foreground" />
            <a 
              href={supplier?.website?.startsWith('http') ? supplier?.website : `https://${supplier?.website}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary hover:underline"
            >
              {supplier?.website}
            </a>
          </div>
        )}
      </div>

      <div className="bg-muted/50 rounded-lg p-3 mb-4">
        <div className="flex items-center justify-between">
          <span className="text-sm text-muted-foreground">Consommables liés</span>
          <span className="text-lg font-semibold text-foreground">{consumablesCount || 0}</span>
        </div>
      </div>

      {supplier?.notes && (
        <p className="text-xs text-muted-foreground mb-4 line-clamp-2">{supplier?.notes}</p>
      )}

      <div className="flex gap-2">
        <Button
          variant="outline"
          size="sm"
          iconName="Edit"
          onClick={onEdit}
          className="flex-1"
        >
          Modifier
        </Button>
        <Button
          variant="outline"
          size="sm"
          iconName="Trash2"
          onClick={onDelete}
        >
          <Icon name="Trash2" size={16} />
        </Button>
      </div>
    </div>
  );
};

export default SupplierCard;